<template>
	<div class="form-group">
		<label v-if="name && hideName === false" class="control-label" :for="uniqueId"> {{ $t('label.' + name) }} <small v-if="crequired">*</small></label>
		<div v-if="cache.dataReady" class="form-inline">
			<div class="badge badge-primary tag mb-1 text-nowrap" v-for="(i, tag) in selection">
				<div class="text-truncate" style="max-width: 150px; display: inline-block">{{categories[tag] ? categories[tag].name : $t('status.error')}}</div>
				<i class="fa fa-close btn-tag" @click="setCategory(tag, false)" v-if="!csingle"></i>
			</div>
			<div class="col p-0">
				<input
					type="text"
					class="form-control"
					:class="{'is-danger': errors.length > 0}"
					:id="uniqueId"
					v-model="autocompleteStub"
					:placeholder="cplaceholder"
					style="padding: 2px 0; width: 100%"
					@keyup.enter="setCategory(filteredCategories[0], !selection[filteredCategories[0]]); autocompleteStub = ''; expanded = false"
					@keydown.delete="autocompleteStub == '' && setCategory(Object.keys(selection).slice(-1)[0], false)">
				<div class="view-button-holder">
					<button type="button" class="btn btn-link btn-small m-0" @click="expanded = !expanded"><i class="fa fa-chevron-down text-muted"></i></button>
				</div>
				<div class="completions-box card" :class="{'expanded': autocompleteStub.length !== 0 || expanded}">
					<category-recursive
						:category-id="0"
						:only-filtered="!expanded"
						:filtered-ids="filteredCategories"
						:selection="selection"
						@selected="setCategory($event.id, $event.value); autocompleteStub = ''; expanded = false"></category-recursive>
					<div class="text-muted text-center font-italic" v-if="filteredCategories.length === 0 && !expanded">
						(няма резултати)
					</div>
				</div>
				<span v-show="errors.length > 0" v-for="error in errors" class="help is-danger">{{ error }}</span>
			</div>
		</div>
	</div>
</template>

<script>
var cache = require('./category-cache');
module.exports = {
	name: 'f-category',
	props: {
		value: {type: String, default: ''},
		name: {type: String},
		hideName: {type: null, default: false},
		cplaceholder: {type: String, default: ''},
		crequired: {type: Boolean, default: false},
		csingle: {type: Boolean, default: false},
		errors: {type: Array, default: () => ([])}
	},
	data: () => ({
		selection: {},
		uniqueId: 'input-' + Math.random().toString(16).slice(2),
		cache: cache.data,
		autocompleteStub: '',
		expanded: false
	}),
	computed: {
		categories () {
			return this.cache.categories;
		},
		filteredCategories () {
			let filtered = [];
			for (let categoryId in this.cache.categories) {
				let category = this.cache.categories[categoryId];
				if (this.autocompleteStub !== '' && category.name.toLowerCase().indexOf(this.autocompleteStub.toLowerCase()) !== -1) {
					filtered.push(category.id);
				}
			}
			return filtered;
		}
	},
	watch: {
		value (value) {
			let values = [];
			if (value + '' !== '') {
				values = (value + '').split(',');
			}
			let selection = {};
			for (var categoryId of values) {
				selection[categoryId] = true;
			}
			this.selection = selection;
		}
	},
	created () {
		cache.prepare(this);
		this.$options.watch.value.call(this, this.value);
	},
	methods: {
		setCategory (id, value) {
			if (id && !!this.selection[id] !== !!value) {
				if (value) {
					if (this.csingle) {
						this.selection = {[id]: true};
					} else {
						this.$set(this.selection, id, true);
					}
				} else {
					this.$delete(this.selection, id);
				}
				this.$emit('input', Object.keys(this.selection).join(','));
			}
		}
	},
	components: {
		'category-recursive': require('./recursive.vue')
	}
};
</script>

<style media="screen">
.completions-box {
	display: none;
	position: absolute;
	/*border: 1px solid rgb(83, 83, 83);*/
	/*background-color: white;*/
	z-index: 10;
	padding: 10px;
	min-width: 15rem;
	overflow: hidden;
	margin-top: -1rem;
	width: 100%;
	top: 100%;
	left: 0;
}
.completions-box.expanded {
	display: block;
}
.view-button-holder {
	position: absolute;
	top: 10px;
	right: 0;
}
</style>



// WEBPACK FOOTER //
// f-category.vue?b688ecda